import { TableColumn } from 'liyu-pc-base/typing';
import { Record, SearchConfig } from 'liyu-pc-base/components/remotePages/typing';
import { btn_list, config, head_btn_list } from './permission-organization-config';
import { event_obj } from 'liyu-pc-base/init-plugin';
import { reactive } from 'vue';
import { useUserStore } from 'liyu-pc-base/init-plugin';

export default () => {
  const userStore = useUserStore();
  const current_org = userStore.currentOrg; // 当前组织org

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写账套名称',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org.id,
      aim_org_id: current_org.id,
      is_active: true,
      name: '',
      get_role: true,
    }),
    options: {},
  };

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [
      {
        type: 'remoteselect',
        name: 'aim_org_id',
        label: '隶属组织',
        disabled: false,
        allowClear: true,
        labelKey: 'name',
        valueKey: 'id',
        placeholder: '请选择隶属组织',
        datasourceType: 'remote',
        mode: 'default',
        default: true,
        modalType: 'select-org-id',
      },
      {
        type: 'input',
        name: 'username',
        label: '手机号',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填手机号',
      },
      {
        type: 'input',
        name: 'realname',
        label: '姓名',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填姓名',
      },
      {
        type: 'select',
        name: 'manage_type',
        label: '用户类型',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填姓名',
      },
      {
        type: 'remoteselect',
        name: 'role_ids',
        label: '角色',
        disabled: false,
        placeholder: '请选择角色',
        datasourceType: 'remote',
        mode: 'multiple',
        allowClear: true,
        modalType: 'liyu_permission-role',
      },
    ],
    rules: {
      username: [{ required: true, pattern: /^1[123456789]\d{9}$/, message: '请输入正确手机号' }],
      realname: [{ required: true, message: '请输入姓名' }],
    },
    model: {
      org_id: current_org?.id,
      id: null,
      username: '',
      realname: '',
      aim_org_id: current_org?.id,
    },
    options: {
      manage_type: [
        { label: '普通用户', value: 0 },
        { label: '超级管理员', value: 2 },
      ],
    },
  };

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '账套名称',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填组织名称',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org.id,
      id: null,
      username: '',
      realname: '',
      title: '',
      aim_org_id: '',
      email: '',
    }),
    options: {},
  };

  const titleList = {
    title: '账套管理',
    addModalTitle: '新建账套',
    updateTitle: '修改',
    is_create: false, // 是否有【新建】按钮
    is_update: true, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      aim_org_id: 'id',
    },
    delete: {
      person_id: 'id',
    },
    recover: {
      person_id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      aim_org_id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      width: 50,
      dataIndex: 'index',
      checked: true,
      fixed: 'left',
    },
    {
      title: '名称',
      dataIndex: 'name',
      checked: true,
      fixed: 'left',
    },

    {
      title: '是否可用',
      width: 100,
      dataIndex: 'is_active',
      checked: true,
      resizable: true,
      cellComponent: 'boolean',
      name1: '可用',
      name2: '禁用',
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '可用', value: 'true' },
        { text: '禁用', value: 'false' },
      ],
    },
    {
      title: '操作',
      width: 50,
      checked: true,
      dataIndex: 'action',
      cellComponent: 'action',
      fixed: 'right',
    },
  ];

  return {
    searchConfig: search_config,
    formModalConfig: edit_model_config,
    updateFormModalConfig: update_model_config,
    queryData: '/org/query_organization_list',
    addData: '/org/create_organization',
    updateData: '/org/update_organization',
    getData: '/org/get_organization',
    removeData: null,
    recoverData: null,
    baseColumns: baseColumns,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj(),
    base_search_condition_config_list: [],
    default_search_condition_config_list: [[]],
    condition_group_config_list: [],
    is_show_advantage: false,
    is_show_normal_search: true,
    is_only_show_advantage: false,
    is_only_show_normal_search: true,
    queryConditionGroupData: null,
    isView: false,
  };
};
